import i18n from '@/i18n/config';

const formatters = new Map<string, Intl.NumberFormat>();

/**
 * The canonical quality score carries one decimal (#1203). Shown as the
 * language writes it — 84, 79.5 in English, 79,5 in ru/uk/es — and never
 * rounded to an integer: "80" on a 79.5 record would sit in a row the
 * "80–100" filter does not return. A whole score shows no trailing ",0".
 */
export function formatQualityScore(
  score: number,
  language: string = i18n.language || 'en'
): string {
  let formatter = formatters.get(language);
  if (!formatter) {
    formatter = new Intl.NumberFormat(language, { maximumFractionDigits: 1 });
    formatters.set(language, formatter);
  }
  return formatter.format(score);
}
